import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
  useGetList,
  NumberInput,
  useRecordContext,
} from 'react-admin';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';
import RolePermissionManager from '../../components/RolePermissionManager';
import { useRolePermissionEditTransform } from '../../hooks/useRolePermissionTransform';

const EditTitle = () => {
  const record = useRecordContext();
  return (
    <span>{record ? `Editar Grupo: ${record.groupName}` : 'Editando...'}</span>
  );
};

const DashboardGroupsEdit = () => {
  // Hook para transformación de roles
  const { transformForSave } = useRolePermissionEditTransform();
  
  // Obtener lista de plantas
  const { data: plants, isLoading: plantsLoading } = useGetList('plants', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'plantName', order: 'ASC' },
  });

  const plantChoices = plants
    ? plants.map((plant: any) => ({
        id: plant.id,
        name: plant.plantName,
      }))
    : [];

  return (
    <Edit title={<EditTitle />} redirect='list' transform={transformForSave}>
      <Card sx={{ maxWidth: 800, margin: 'auto' }}>
        <CardContent>
          <Box display='flex' alignItems='center' mb={3}>
            <DashboardIcon
              sx={{ mr: 2, fontSize: 32, color: 'primary.main' }}
            />
            <Typography variant='h5' component='h1'>
              Editar Grupo de Dashboard
            </Typography>
          </Box>

          <SimpleForm>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 2,
                width: '100%',
              }}
            >
              <TextInput
                source='groupName'
                label='Nombre del Grupo'
                validate={[required()]}
                fullWidth
                helperText='Nombre descriptivo para el grupo de dashboards'
              />

              <NumberInput
                source='position'
                label='Posición'
                helperText='Orden de visualización'
                fullWidth
              />
            </Box>
            <SelectInput
              source='plantId'
              label='Planta Asociada'
              choices={plantChoices}
              validate={[required()]}
              isLoading={plantsLoading}
              fullWidth
              helperText='Selecciona la planta a la que pertenece este grupo'
            />
            
            <RolePermissionManager
              title="Permisos del Grupo de Dashboards"
              subtitle="Modificar roles y permisos para este grupo"
              helperText="Los permisos aplicarán a todos los dashboards dentro de este grupo."
              showCard={false}
            />
          </SimpleForm>
        </CardContent>
      </Card>
    </Edit>
  );
};

export default DashboardGroupsEdit;
